/* GAP configurator add-on, loaded by the Custom Liquid section in templates/page.gap-configurator.json. Desktop layout
   (900 px and wider only; phones are untouched): the page grows with the screen, the options panel grows from 360 to
   460 px, the preview fills the rest and everything fits one screen under the site header. --gap-hdr is the header
   height (measured here) and --pbar the Shopify preview bar (set by gap-cart-guard.js). */
(function () {
  var css = document.createElement('style');
  css.textContent = '@media (min-width:900px){'
    + '[data-gapcfg].gapcfg{--pw:clamp(360px,30vw,460px);--gx:clamp(20px,2.5vw,48px);--ch:calc(100vh - var(--gap-hdr,54px) - var(--pbar,0px) - 76px);'
    + 'max-width:min(1640px,100%)!important;padding:10px clamp(16px,2vw,32px) 20px!important;min-height:0!important;'
    + 'grid-template-columns:minmax(0,1fr) var(--pw)!important;column-gap:var(--gx)!important;row-gap:8px}'
    + '[data-gapcfg] .gapcfg__top{padding:0!important;min-height:44px}'
    + '[data-gapcfg] .gapcfg__stage{height:var(--ch);min-height:420px!important;padding:12px 0!important;align-self:start}'
    + '[data-gapcfg] .gapcfg__dock{bottom:auto!important;margin-top:0!important;position:sticky!important;top:calc(var(--gap-hdr,54px) + 10px);'
    + 'max-height:var(--ch);overflow-y:auto;overscroll-behavior:contain}'
    + '[data-gapcfg] .gapcfg__frame{--AW:calc((min(1640px,100vw) - var(--pw) - var(--gx) - 2 * clamp(16px,2vw,32px)) * .72);--AH:calc(max(420px,var(--ch)) - 210px)}'
    /* product picker: 8 cards in two rows that fit the screen */
    + '[data-gapcfg] .gapcfg__pick{padding-top:0!important}'
    + '[data-gapcfg] .gapcfg__lead{margin:0 0 10px!important}'
    + '[data-gapcfg] .gapcfg__grid{grid-template-columns:repeat(4,minmax(0,1fr))!important;grid-auto-rows:clamp(170px,calc((100vh - var(--gap-hdr,54px) - var(--pbar,0px) - 150px) / 2),340px)!important;gap:clamp(10px,1.2vw,18px)!important}'
    + '}'
    + '@media (min-width:1200px){[data-gapcfg] .gapcfg__card b{white-space:nowrap}}';
  document.head.appendChild(css);
  var root = document.documentElement;
  function hdr() {
    var g = document.querySelector('[data-gapcfg]');
    if (!g) return;
    var top = Math.max(0, Math.round(g.getBoundingClientRect().top + window.scrollY));
    var v = top + 'px';
    if (root.style.getPropertyValue('--gap-hdr') !== v) root.style.setProperty('--gap-hdr', v);
  }
  hdr();
  document.addEventListener('DOMContentLoaded', hdr);
  window.addEventListener('load', hdr);
  window.addEventListener('resize', hdr);
})();

/* One page colour and square-ish corners (Uğur, 2026-10-24): the page around the configurator is the configurator's own
   colour instead of white (and on wide screens the preview area too), and boxes, buttons and pills use a 4 px radius.
   Round icon buttons stay round. */
(function () {
  var css = document.createElement('style');
  css.textContent = 'html.gapcfg-page body{background:#F5F2EF!important}'
    + '@media (min-width:900px){[data-gapcfg] .gapcfg__stage{background:transparent!important}}'
    + '[data-gapcfg] .gapcfg__pcard,[data-gapcfg] .gapcfg__thumb,[data-gapcfg] .gapcfg__thumb img,[data-gapcfg] .gapcfg__mock,'
    + '[data-gapcfg] .gapcfg__card,[data-gapcfg] .gapcfg__cards[data-paper] .gapcfg__card,[data-gapcfg] .gapcfg__tab,[data-gapcfg] .gapcfg__add,[data-gapcfg] .gapcfg__wallbtn,'
    + '[data-gapcfg] .gapcfg__price,[data-gapcfg] .gapcfg__done,[data-gapcfg] .gapcfg__unit,[data-gapcfg] .gapcfg__unit button,'
    + '[data-gapcfg] .gapcfg__orient button,[data-gapcfg] .gapcfg__seg,[data-gapcfg] .gapcfg__seg button,'
    + '[data-gapcfg] .gapcfg__bplace,[data-gapcfg] .gapcfg__bplace button,[data-gapcfg] .gapcfg__pgroups button,'
    + '[data-gapcfg] .gapcfg__swatch,[data-gapcfg] .gapcfg__rec,[data-gapcfg] .gapcfg__badge,[data-gapcfg] .gapcfg__use,'
    + '[data-gapcfg] .gapcfg__custom input,[data-gapcfg] .gapcfg__custom button,[data-gapcfg] .gapcfg__dock,'
    + '.gapw__wall,.gapw__row button{border-radius:4px!important}';
  document.head.appendChild(css);
})();

/* Options column (Uğur, 2026-10-24), wide screens only: the options sit in a white full-height column against the right
   edge of the screen, directly under the site header, with Add to cart fixed at its bottom. The product picker keeps its
   right-hand margin. */
(function () {
  var css = document.createElement('style');
  css.textContent = '@media (min-width:900px){'
    + '[data-gapcfg].gapcfg{max-width:100%!important;padding:0 0 0 clamp(16px,2vw,32px)!important;align-items:start}'
    + '[data-gapcfg].gapcfg:has([data-pick]:not([hidden])){padding:10px clamp(16px,2vw,32px) 20px!important}'
    + '[data-gapcfg] .gapcfg__top{grid-column:1!important}'
    + '[data-gapcfg].gapcfg:has([data-cfg]:not([hidden])) .gapcfg__top{padding-top:10px!important}'
    + '[data-gapcfg] .gapcfg__dock{grid-column:2!important;grid-row:1 / span 20!important;align-self:start;position:sticky!important;top:var(--gap-hdr,54px)!important;'
    + 'height:calc(100vh - var(--gap-hdr,54px) - var(--pbar,0px))!important;max-height:none!important;border-radius:0!important;box-shadow:none!important;'
    + 'border-left:1px solid #E2DDD5;background:#fff;display:flex!important;flex-direction:column}'
    + '[data-gapcfg] .gapcfg__dock .gapcfg__cta{margin-top:auto!important;border-top:1px solid #E2DDD5;padding-top:12px}'
    + '}';
  document.head.appendChild(css);
})();

/* Size cards smallest first, on every screen (Uğur, 2026-10-25): a product lists its sizes in the order they were
   created, so the size cards are put in order of area here. Only cards named like "30×40 cm" move; the Custom size card
   stays last. */
(function () {
  function area(c) {
    var b = c.querySelector('b'), m = b && /^(\d+(?:\.\d+)?)×(\d+(?:\.\d+)?) cm$/.exec(b.textContent);
    return m ? m[1] * m[2] : null;
  }
  function sort(box) {
    var sized = [].filter.call(box.children, function (c) { return area(c) != null; });
    if (sized.length < 2) return;
    var want = sized.slice().sort(function (a, b) { return area(a) - area(b); });
    if (want.every(function (c, i) { return c === sized[i]; })) return;
    var next = sized[sized.length - 1].nextSibling;
    want.forEach(function (c) { box.insertBefore(c, next); });
  }
  function start() {
    [].forEach.call(document.querySelectorAll('[data-gapcfg] [data-cards]'), function (box) {
      sort(box);
      new MutationObserver(function () { sort(box); }).observe(box, { childList: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Step guide (Uğur, 2026-10-25; on wide screens too since 2026-10-27). On the first screen the round Add your photo button (orange) pulses until
   it is tapped. After the photo is in, the Size sheet opens and the customer goes through the bottom tabs in order: once a
   choice is made in the open sheet (a card, a paper group or Use this size) that tab gets a green tick and the next tab
   flashes orange once a second until it is tapped; the open tab itself never flashes. Tabs a product does not have are simply not there. Done stays
   hidden until every tab has a choice; then it shows in the price orange with white text and pulses (with a light sweep)
   until it is tapped. Wide screens have no Done (the options column is always open), so there Add to cart stays visible
   and pulses the same way once every tab has a choice. From then on the yellow On wall button also pulses, more slowly
   (every 2 s), until it is tapped, so the customer can look on a wall or go to the cart. Starts over for each product. No pulsing when the device asks for
   reduced motion. */
(function () {
  var css = document.createElement('style');
  css.textContent = '@keyframes gapStep{0%,100%{box-shadow:0 0 0 0 rgba(255,140,58,0);transform:scale(1)}50%{box-shadow:0 0 0 6px rgba(255,140,58,.55);transform:scale(1.04)}}'
    + '@keyframes gapCueSweep{0%{transform:translateX(-120%)}60%,100%{transform:translateX(120%)}}'
    + '.gapcfg .gapcfg__done.is-go{background:#FF8C3A!important;color:#fff!important;font-weight:700;position:relative;overflow:hidden}'
    + '.gapcfg .gapcfg__done.is-go::after{content:"";position:absolute;inset:0;pointer-events:none;transform:translateX(-120%);'
    + 'background:linear-gradient(110deg,transparent 30%,rgba(255,255,255,.65) 50%,transparent 70%)}'
    + '.gapcfg .gapcfg__done.is-go.is-pulse{animation:none}'
    + '.gapcfg .gapcfg__done.is-go.is-cue{animation:gapStep 1s ease-in-out infinite!important}'
    + '.gapcfg .gapcfg__done.is-go.is-cue::after{animation:gapCueSweep 1.5s ease-in-out infinite}'
    + '.gapcfg .gapcfg__add.is-cue{position:relative;overflow:hidden;animation:gapStep 1s ease-in-out infinite}'
    + '.gapcfg .gapcfg__add.is-cue::after{content:"";position:absolute;inset:0;pointer-events:none;transform:translateX(-120%);'
    + 'background:linear-gradient(110deg,transparent 30%,rgba(255,255,255,.65) 50%,transparent 70%);animation:gapCueSweep 1.5s ease-in-out infinite}'
    + '@keyframes gapWallSlow{0%,100%{box-shadow:0 0 0 0 rgba(245,184,46,.9);transform:scale(1)}50%{box-shadow:0 0 0 10px rgba(245,184,46,0);transform:scale(1.05)}}'
    + '.gapcfg .gapcfg__wallbtn.is-slow{animation:gapWallSlow 2s ease-in-out infinite!important}'
    + 'html.gap-steps-wait .gapcfg .gapcfg__done{visibility:hidden}'
    + '.gapcfg .gapcfg__tab.is-done:not([aria-selected=true]){border-color:#2E8B57!important;background:#EEF7F1!important}'
    + '.gapcfg .gapcfg__tab.is-done b::before{content:"\\2713  ";color:#2E8B57;font-weight:800}'
    + '.gapcfg .gapcfg__tab.is-done[aria-selected=true] b::before{color:inherit}'
    + '@keyframes gapStepTab{0%,100%{background:#FFF3EA;color:#1E1B18;box-shadow:0 0 0 0 rgba(255,140,58,.9)}50%{background:#FF8C3A;color:#fff;box-shadow:0 0 0 8px rgba(255,140,58,0)}}'
    + '.gapcfg .gapcfg__tab.is-next:not([aria-selected=true]){border-color:#FF8C3A!important;animation:gapStepTab 1s ease-in-out infinite}'
    + '.gapcfg .gapcfg__tab.is-next:not([aria-selected=true]) small{color:inherit!important}'
    + '@keyframes gapStepStart{0%,100%{box-shadow:0 0 0 0 rgba(255,140,58,.9);transform:scale(1)}50%{box-shadow:0 0 0 14px rgba(255,140,58,0);transform:scale(1.05)}}'
    + '.gapcfg .gapcfg__start{background:#FF8C3A!important;border:2px solid #FF8C3A!important;color:#fff!important}'
    + '.gapcfg .gapcfg__start .gapcfg__plus,.gapcfg .gapcfg__start .gapcfg__hint{color:#fff!important}'
    + '.gapcfg .gapcfg__start:not(.is-tapped){animation:gapStepStart 1s ease-in-out infinite}'
    + '@media (prefers-reduced-motion:reduce){.gapcfg .gapcfg__tab.is-next,.gapcfg .gapcfg__start,.gapcfg .gapcfg__done.is-go.is-cue,.gapcfg .gapcfg__done.is-go.is-cue::after,.gapcfg .gapcfg__add.is-cue,.gapcfg .gapcfg__add.is-cue::after,.gapcfg .gapcfg__wallbtn.is-slow{animation:none!important}}';
  document.head.appendChild(css);
  var html = document.documentElement, done = {}, prod = '', wasGo = false, addCued = '', wallCued = '';
  function q(s) { return document.querySelector(s); }
  function name(t) { var b = t.querySelector('b'); return b ? b.textContent.trim() : ''; }
  function tabs() { return [].slice.call(document.querySelectorAll('[data-gapcfg] [data-tabs] .gapcfg__tab')); }
  function openTab() { return tabs().filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0]; }
  function hasPhoto() { var f = q('[data-gapcfg] [data-frame]'); return !!f && !f.hidden; }
  function decorate() {
    var list = tabs(), phone = window.innerWidth < 900;
    var title = (q('[data-gapcfg] [data-title]') || {}).textContent || '';
    if (title !== prod) { prod = title; done = {}; }
    var next = null;
    if (hasPhoto()) list.some(function (t) { if (!done[name(t)]) { next = name(t); return true; } return false; });
    list.forEach(function (t) {
      var n = name(t);
      t.classList.toggle('is-done', !!done[n]);
      t.classList.toggle('is-next', n === next);
    });
    var all = list.length > 0 && list.every(function (t) { return !!done[name(t)]; });
    html.classList.toggle('gap-steps-wait', phone && list.length > 0 && !all);
    /* wide screens: Add to cart pulses once every tab has a choice, until it is clicked (once per product) */
    var add = q('[data-gapcfg] [data-add]');
    if (add) {
      if (!add.hasAttribute('data-cue')) {
        add.setAttribute('data-cue', '');
        add.addEventListener('click', function () { add.classList.remove('is-cue'); addCued = prod + '|x'; });
      }
      if (!phone && all && addCued !== prod + '|x' && addCued !== prod) { addCued = prod; add.classList.add('is-cue'); }
      if (phone || !all) add.classList.remove('is-cue');
      if (!all && addCued === prod) addCued = '';
    }
    /* On wall: slow pulse once every tab has a choice, on every screen, until it is tapped (once per product) */
    var wb = q('[data-gapcfg] .gapcfg__wallbtn');
    if (wb) {
      if (!wb.hasAttribute('data-cue')) {
        wb.setAttribute('data-cue', '');
        wb.addEventListener('click', function () { wb.classList.remove('is-slow'); wallCued = prod; });
      }
      wb.classList.toggle('is-slow', all && wallCued !== prod);
    }
  }
  /* Add your photo pulses on the first screen until it is tapped */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gapcfg] [data-start]');
    if (b) b.classList.add('is-tapped');
  }, true);
  /* an option picked in the open sheet (a card, a paper group or Use this size) completes that tab (capture: runs before the configurator re-renders the tabs) */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var c = e.target.closest('[data-gapcfg] [data-sheet] .gapcfg__card, [data-gapcfg] [data-sheet] .gapcfg__pgroups button, [data-gapcfg] [data-cuse]');
    if (!c || c.disabled || (c.matches('.gapcfg__card') && /Custom size/.test(c.textContent))) return;
    var t = openTab();
    if (t) { done[name(t)] = true; setTimeout(decorate, 0); }
  }, true);
  /* Done: pulse from the moment it can be used until it is tapped */
  setInterval(function () {
    var d = q('[data-gapcfg] [data-done]');
    if (!d) return;
    if (!d.hasAttribute('data-cue')) {
      d.setAttribute('data-cue', '');
      d.addEventListener('click', function () { d.classList.remove('is-cue'); });
    }
    var go = d.classList.contains('is-go') && !html.classList.contains('gap-steps-wait');
    if (go && !wasGo) d.classList.add('is-cue');
    if (!go) d.classList.remove('is-cue');
    wasGo = go;
  }, 300);
  function start() {
    var box = q('[data-gapcfg] [data-tabs]');
    if (!box) return;
    new MutationObserver(decorate).observe(box, { childList: true });
    var fr = q('[data-gapcfg] [data-frame]');
    if (fr) new MutationObserver(decorate).observe(fr, { attributes: true, attributeFilter: ['hidden'] });
    window.addEventListener('resize', decorate);
    decorate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* One row per option list on phones (Uğur, 2026-10-25): sizes, mounts, frame colours, borders and their colour chips all
   fit the screen width side by side, with no sideways scrolling; the boxes shrink and their text wraps instead. */
(function () {
  var css = document.createElement('style');
  css.textContent = '@media (max-width:899px){'
    + '[data-gapcfg] .gapcfg__cards{flex-wrap:nowrap!important;overflow:visible!important;gap:6px!important;padding:2px 0 6px!important}'
    + '[data-gapcfg] .gapcfg__cards .gapcfg__card{flex:1 1 0!important;min-width:0!important;max-width:none!important;padding:6px 3px!important;min-height:52px!important;gap:2px!important}'
    + '[data-gapcfg] .gapcfg__cards .gapcfg__card b{font-size:13px!important;line-height:1.15!important;white-space:normal!important;overflow-wrap:anywhere}'
    + '[data-gapcfg] .gapcfg__cards .gapcfg__card span{font-size:12px!important;line-height:1.15!important}'
    + '[data-gapcfg] .gapcfg__cards .gapcfg__card .gapcfg__rec{font-size:10px!important;padding:1px 4px!important;letter-spacing:-.1px;white-space:nowrap;max-width:100%}'
    + '[data-gapcfg] .gapcfg__cards--colours .gapcfg__card{min-height:46px!important;padding:5px 2px!important}'
    + '[data-gapcfg] .gapcfg__cards--colours .gapcfg__swatch{width:18px!important;height:18px!important}'
    + '[data-gapcfg] .gapcfg__cards--colours .gapcfg__card b{font-size:12px!important}'
    + '}';
  document.head.appendChild(css);
})();

/* On your wall (Uğur, 2026-10-25): the close button becomes an orange, pulsing Back button in the top right corner
   (where the X was); it does the same thing (back to the design). */
(function () {
  var css = document.createElement('style');
  css.textContent = '@keyframes gapWallBack{0%,100%{box-shadow:0 0 0 0 rgba(255,140,58,.9);transform:scale(1)}50%{box-shadow:0 0 0 10px rgba(255,140,58,0);transform:scale(1.04)}}'
    + '.gapw .gapw__x{margin-left:auto!important;width:auto!important;min-width:0!important;height:40px;padding:0 14px 0 10px!important;border-radius:4px!important;'
    + 'background:#FF8C3A!important;color:#fff!important;border-color:#FF8C3A!important;'
    + 'font-size:0!important;display:inline-flex!important;align-items:center;gap:4px;animation:gapWallBack 1s ease-in-out infinite}'
    + '.gapw .gapw__x::before{content:"\\2039  Back";font-size:15px;font-weight:700;line-height:1;color:#fff}'
    + '@media (prefers-reduced-motion:reduce){.gapw .gapw__x{animation:none}}';
  document.head.appendChild(css);
})();

/* Next step inside the open sheet (Uğur, 2026-10-28: after every choice the next choice flashes, in every flow).
   The bottom tabs already flash in turn; this covers the moment a sheet is open and nothing in it is picked yet (right
   after the photo, after a collage's Done, after tapping a tab): the option that is already selected (or the first one)
   flashes softly until the customer picks one, and in Custom size the Use this size button does. Paper first flashes the
   selected paper type, then the selected paper. */
(function () {
  var css = document.createElement('style');
  css.textContent = '@keyframes gapStepPick{0%,100%{box-shadow:0 0 0 0 rgba(255,140,58,.95)}50%{box-shadow:0 0 0 6px rgba(255,140,58,0)}}'
    + '[data-gapcfg] [data-sheet] .is-pick{animation:gapStepPick 1s ease-in-out infinite!important;position:relative;z-index:1}'
    + '@media (prefers-reduced-motion:reduce){[data-gapcfg] [data-sheet] .is-pick{animation:none!important}}';
  document.head.appendChild(css);
  function vis(e) { return !!e && !e.hidden && e.getClientRects().length > 0; }
  function first(list) { for (var i = 0; i < list.length; i++) if (vis(list[i]) && !list[i].disabled) return list[i]; return null; }
  var pickedIn = '';
  document.addEventListener('click', function (e) {
    var c = e.target.closest && e.target.closest('[data-gapcfg] [data-sheet] .gapcfg__pgroups button');
    if (c) pickedIn = 'pg';
  }, true);
  function target() {
    var root = document.querySelector('[data-gapcfg]'), sheet = root && root.querySelector('[data-sheet]');
    var fr = root && root.querySelector('[data-frame]');
    if (!vis(sheet) || !fr || fr.hidden) return null;
    var tab = root.querySelector('[data-tabs] .gapcfg__tab[aria-selected="true"]');
    if (!tab || tab.classList.contains('is-done')) { pickedIn = ''; return null; }
    var cust = sheet.querySelector('[data-custom]');
    if (vis(cust)) return first(sheet.querySelectorAll('[data-cuse]'));
    var pg = sheet.querySelector('.gapcfg__pgroups');
    if (vis(pg) && pickedIn !== 'pg') return first(pg.querySelectorAll('button[aria-checked="true"]')) || first(pg.querySelectorAll('button'));
    var lists = sheet.querySelectorAll('.gapcfg__cards');
    for (var i = 0; i < lists.length; i++) {
      if (!vis(lists[i])) continue;
      var cards = [].filter.call(lists[i].querySelectorAll('.gapcfg__card'), function (c) { return !/^\s*Custom size/.test(c.textContent); });
      return first(cards.filter(function (c) { return c.getAttribute('aria-checked') === 'true'; })) || first(cards);
    }
    return null;
  }
  var cur = null, lastTab = '';
  setInterval(function () {
    var tab = document.querySelector('[data-gapcfg] [data-tabs] .gapcfg__tab[aria-selected="true"] b');
    var n = tab ? tab.textContent : '';
    if (n !== lastTab) { lastTab = n; pickedIn = ''; }
    var t = target();
    if (t === cur && (!t || t.classList.contains('is-pick'))) return;
    if (cur) cur.classList.remove('is-pick');
    cur = t;
    if (t) t.classList.add('is-pick');
  }, 250);
})();
